/**
 * Card number input used for adding a card
 *
 * Dependent on getCardSpecs() from https://github.paypal.com/ConsumerWeb-Modules/consumerweb-card/blob/master/lib/card-config.js,
 * but you could just supply an object of specifications similar to what getCardSpecs returns.
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { StyleSheet, css } from 'aphrodite';
import { DropdownMenu } from '@paypalcorp/pp-react';

import { cardSpecsPropType, cardSpecPropType } from 'prop-validators';
import { defaultCardSpec, getSpecificCardSpec } from '../utility/card-utils';

const STYLES = StyleSheet.create({
  logoWrapper: {
    height: '100%',
    position: 'absolute',
    top: 0,
    right: 0,
  },
  dropdown: {
    padding: 0,
    textIndent: 12,
    boxSizing: 'content-box',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    appearance: 'none',
    '@-moz-document url-prefix()': {
      textIndent: 2.5,
    },
    '::-ms-expand': { display: 'none' },
  },
  arrow: {
    position: 'absolute',
    right: 10,
    top: 20,
    cursor: 'default',
    pointerEvents: 'none',
  },
  logo: {
    display: 'inline-block',
    marginTop: 12,
    marginRight: 2,
  },
  errorMessage: {
    WebkitTransition: 'all 0.25s ease-in-out',
    MozTransition: 'all 0.25s ease-in-out',
    msTransition: 'all 0.25s ease-in-out',
    OTransition: 'all 0.25s ease-in-out',
    transition: 'all 0.25s ease-in-out',
    marginRight: -2,
    color: 'rgb(0, 0, 0)',
  },
  errorStylesSelect: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
});

class CardType extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardTypeErrorMessage: '',
      showIsRequiredError: false,
      cardTypeIndex: Object.keys(this.props.cardSpecs.cardTypes)
        .map((type) => this.props.cardSpecs.cardTypes[type])
        .findIndex((card) => card.type === this.props.cardType),
    };
  }

  /*
   * Format card typepes into array
   */
  formatCardTypes = (cardTypes = {}) => {
    return Object.keys(cardTypes).map((cardType) => cardTypes[cardType]) || [];
  };

  /*
   * Handle card type change
   */
  handleChange = (index) => {
    const {
      cardSpecs: { cardTypes = {} },
    } = this.props;
    let cardType = this.formatCardTypes(cardTypes)[index];
    this.setState({ cardTypeIndex: index });
    this.props.changeCardType(cardType);
  };

  getCardTypeOptions = (cardTypes) => {
    return this.formatCardTypes(cardTypes).map((item) => {
      return {
        primaryText: item.name,
      };
    });
  };

  render() {
    const {
      country,
      cardSpecs: { cardTypes = {} },
      errorMessage,
    } = this.props;
    let { cardTypeErrorMessage } = this.state;
    let errorMessageClassNames = classNames(css(STYLES.errorMessage), {
      'vx_form-control-message': errorMessage || cardTypeErrorMessage,
    });
    let errorStyles = {
      height: 0,
      padding: 0,
    };
    if (errorMessage || cardTypeErrorMessage) {
      errorStyles = { height: '100%' };
    }

    // Removing card type 'SWITCH' for GB
    if (country === 'GB') {
      delete cardTypes.SWITCH;
    }

    return (
      <div style={{ margin: '10px 2px 0 0', position: 'relative' }}>
        <div style={{ position: 'relative', marginTop: 0 }}>
          <DropdownMenu
            type="button"
            id="cardTypeSelection"
            placeholder=""
            selectedItemIndex={this.state.cardTypeIndex}
            onSelection={this.handleChange}
            label={this.props.label}
            options={this.getCardTypeOptions(cardTypes)}
            errorText={errorMessage || cardTypeErrorMessage}
          />
        </div>
      </div>
    );
  }
}

CardType.propTypes = {
  changeCardType: PropTypes.func.isRequired,
};

export { defaultCardSpec };
export default CardType;
